export const CustomerDetailConstant = {
  PERSONAL_DETAIL_SAGA: "PERSONAL_DETAIL_SAGA",
  PERSONAL_DETAIL_REQUEST: "PERSONAL_DETAIL_REQUEST",
  PERSONAL_DETAIL_RESPONSE: "PERSONAL_DETAIL_RESPONSE",
  PERSONAL_DETAIL_API: "/vendor/customer/:id",

  PHOTOS_UPLOADED_SAGA: "PHOTOS_UPLOADED_SAGA",
  PHOTOS_UPLOADED_REQUEST: "PHOTOS_UPLOADED_REQUEST",
  PHOTOS_UPLOADED_RESPONSE: "PHOTOS_UPLOADED_RESPONSE",
  PHOTOS_UPLOADED_API: "/vendor/customer/:id",

  REVIEWS_SAGA: "REVIEWS_SAGA",
  REVIEWS_REQUEST: "REVIEWS_REQUEST",
  REVIEWS_RESPONSE: "REVIEWS_RESPONSE",
  REVIEWS_API: "/feedback/customer/:id",

  CHARGING_DATA_SAGA: "CHARGING_DATA_SAGA",
  CHARGING_DATA_REQUEST: "CHARGING_DATA_REQUEST",
  CHARGING_DATA_RESPONSE: "CHARGING_DATA_RESPONSE",
  CHARGING_DATA_API: "/vendor/customer/:id",
};
